// extracted by mini-css-extract-plugin
export default {"modalOverlay":"modal-overlay_modalOverlay__nmXW0"};